<div class="scroll-to-top" [ngClass]="{'show-scrollTop': windowScrolled, 'hide-scrollTop': !windowScrolled, 'bottom-reached': bottom}">
  <button mat-raised-button (click)="scrollToTop()">
    <mat-icon>expand_less</mat-icon>
  </button>
</div>